(function () {
    'use strict';

    angular
        .module('app')
        .controller('GuideForConcertGoersController', GuideForConcertGoersController);

    GuideForConcertGoersController.$inject = ['$rootScope', '$stateParams'];

    function GuideForConcertGoersController($rootScope, $stateParams) {
        var GuideForConcertGoersCtrl = this;
        GuideForConcertGoersCtrl.$onInit = init;


        function init() {
            $rootScope.header_inverted = true;

            window.document.title = $stateParams.language == 'da' ? "Guide til koncertgæster - Be My Concert" : "Guide for concertgoers - Be My Concert";
        }

    }
})();